import { useContext } from 'react'
import { contextoTema, type ContextoTema } from './ProveedorTema'

export function useTema(): ContextoTema {
  const valor = useContext(contextoTema)
  if (!valor) throw new Error('useTema debe usarse dentro de ProveedorTema')
  return valor
}
